import React, { useState } from 'react';
import { __ } from '@wordpress/i18n';
import { Button, ToggleControl } from '@wordpress/components';
import ConditionalLogicControlModal from './ConditionalLogicControlModal';

interface ConditionalLogicControlProps extends BlockProps<any> {}

function ConditionalLogicControl(props: ConditionalLogicControlProps) {
	const [isOpen, setOpen] = useState(false);
	const openModal = () => {
		setOpen(true);
	};

	const closeModal = () => {
		setOpen(false);
	};

	const rules = props?.attributes?.gpebConditionalLogic?.rules;
	const ruleCount = rules?.length ?? 0;
	const hasRules = ruleCount > 0;

	return (
		<>
			<ToggleControl
				checked={props.attributes.gpebConditionalLogicEnabled ?? false}
				help={__(
					'Enable conditional logic to show or hide this block based on Gravity Forms conditions.',
					'gp-entry-blocks'
				)}
				label={__('Enable Conditional Logic', 'gp-entry-blocks')}
				onChange={(value) => {
					props.setAttributes({
						gpebConditionalLogicEnabled: value,
					});

					if (!value) {
						closeModal();
					}
				}}
			/>

			{props.attributes.gpebConditionalLogicEnabled && (
				<Button variant="secondary" onClick={openModal}>
					{hasRules
						? __('Edit Rules', 'gp-entry-blocks')
						: __('Add Rules', 'gp-entry-blocks')}
					{hasRules ? (
						<span className="gpeb-badge">{ruleCount}</span>
					) : undefined}
				</Button>
			)}

			{isOpen && (
				<ConditionalLogicControlModal
					{...props}
					onRequestClose={closeModal}
				/>
			)}
		</>
	);
}

export default ConditionalLogicControl;
